import SharedStatusBadge from "@/components/SharedStatusBadge/SharedStatusBadge";
import { TooltipSizes } from "@/components/Tooltip/types";
import { COMPANY_CARD_STATUS } from "@/shared";

import useCardStatusFunctions from "../../../../hooks/useCardStatusFunctions/useCardStatusFunctions";
import { CompanyCardObjectDto } from "../../../../types/types";

interface CardStatusBadgeProps {
  card: CompanyCardObjectDto;
  tooltipSize?: TooltipSizes;
  scrolling?: boolean;
}

const CardStatusBadge = ({
  card,
  tooltipSize,
  scrolling
}: CardStatusBadgeProps) => {
  const { expiredStatusText, offlineStatusText, onlineStatusText } =
    useCardStatusFunctions({ card });

  const renderCustomTooltipText = () => {
    switch (card.status) {
      case COMPANY_CARD_STATUS.Offline:
        return offlineStatusText;
      case COMPANY_CARD_STATUS.Expired: // Display as Deactivated status
        return expiredStatusText;
      case COMPANY_CARD_STATUS.Online:
        return onlineStatusText;
      default:
        return undefined;
    }
  };

  const cardStatusToDisplay =
    card.status === COMPANY_CARD_STATUS.Expired
      ? COMPANY_CARD_STATUS.Deactivated
      : card.status;

  return (
    <SharedStatusBadge
      status={cardStatusToDisplay as COMPANY_CARD_STATUS}
      customTooltipText={renderCustomTooltipText()}
      tooltipSize={tooltipSize}
      showTooltip={!scrolling}
    />
  );
};

export default CardStatusBadge;
